<template>
  <ConfirmationModal
    :title="forModal.title"
    :accept-text="forModal.acceptBtnText"
    :cancel-text="forModal.declineBtnText"
    :accept-button-props="{ color: 'black' }"
    :cancel-button-props="{ color: 'black' }"
    :disable-btns="btnOnLoading"
    @on-accept="banUser"
  >
    <div class="ban-user-content">
      <p>{{ forModal.text }}</p>
    </div>
  </ConfirmationModal>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { ConfirmationModal } from '@/components/common/modal';
import { confirmModalContent } from '@/components/common/modal/data/confirmModalContent';
import { useStore } from 'vuex';

export default defineComponent({
	name: 'BanModal',
	components: { ConfirmationModal },
	setup (props, { attrs }) {
		const store = useStore();
		const btnOnLoading = ref(false);
		const propsModal = attrs.modalProps;
		const forModal = propsModal.isBanned ? confirmModalContent.userBanned : confirmModalContent.user;

		const banUser = propsModal?.fromEditing
			? async () => {
				btnOnLoading.value = true;
				await store.dispatch('editUser/toggleBan')
					.finally(() => { btnOnLoading.value = false; });
				store.dispatch('modal/closeModal');
			}
			: async () => {
				btnOnLoading.value = true;
				await store.dispatch('users/toggleBan', propsModal).finally(() => { btnOnLoading.value = false; });
				store.dispatch('modal/closeModal');
			};

		return {
			forModal,
			banUser,
			btnOnLoading,
		};
	},
});
</script>

<style scoped lang="scss">
  .ban-user-content {
    width: 100%;
    max-width: 360px;
    text-align: center;
    margin: 20px 25px
  }
</style>
